// Grade 2026/02 transcrita dos PDFs da UNIFENAS-BH.
// O campo sourcePdf preserva as tabelas e o texto extraídos, inclusive escalas de ambulatório.
// As datas dos blocos vêm do calendário já cadastrado em ../data.js; os PDFs de horário não as informam.
// ESTRUTURA DIFERENTE: grade única por semestre; turmas A/B/C têm atividades distintas.
import sourcePdf from "./sources/period1.json";
const periodDataset = {
  label: "1º período",
  syndromes: {
  "geral": {
    "name": "Grade geral",
    "short": "Geral"
  }
},
  blocks: [
  {
    "number": 1,
    "start": "2026-07-28",
    "end": "2026-08-21",
    "label": "1º bloco"
  },
  {
    "number": 2,
    "start": "2026-08-24",
    "end": "2026-09-25",
    "label": "2º bloco"
  },
  {
    "number": 3,
    "start": "2026-09-28",
    "end": "2026-10-30",
    "label": "3º bloco"
  },
  {
    "number": 4,
    "start": "2026-11-03",
    "end": "2026-12-04",
    "label": "4º bloco"
  }
],
  defaultRotations: {
  "A": {
    "1": "geral",
    "2": "geral",
    "3": "geral",
    "4": "geral"
  },
  "B": {
    "1": "geral",
    "2": "geral",
    "3": "geral",
    "4": "geral"
  },
  "C": {
    "1": "geral",
    "2": "geral",
    "3": "geral",
    "4": "geral"
  }
},
  baseSchedule: {
  "geral": {
    "1": {
      "am1": {
        "1": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Silvana Eloi",
          "location": "C.S. Heliópolis",
          "kind": "class"
        },
        "2": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Silvana Eloi",
          "location": "C.S. Heliópolis",
          "kind": "class"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "José Roberto",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Michelle L",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "José Roberto",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Michelle L",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "am2": {
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "1": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Silvana Eloi",
          "location": "C.S. Heliópolis",
          "kind": "class"
        },
        "2": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Silvana Eloi",
          "location": "C.S. Heliópolis",
          "kind": "class"
        }
      }
    },
    "2": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        }
      },
      "pm1": {
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        },
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "3": {
      "am1": {
        "1": {
          "code": "PLh",
          "title": "Prática de laboratório de histologia",
          "professor": "Eliane Perlatto",
          "location": "Lab. Histologia",
          "kind": "pl"
        },
        "2": {
          "code": "PLh",
          "title": "Prática de laboratório de histologia",
          "professor": "Eliane Perlatto",
          "location": "Lab. Histologia",
          "kind": "pl"
        },
        "3": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "André Almeida",
          "location": "Lab. Anatomia",
          "kind": "pl"
        },
        "4": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "André Almeida",
          "location": "Lab. Anatomia",
          "kind": "pl"
        }
      },
      "am2": {
        "1": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "André Almeida",
          "location": "Lab. Anatomia",
          "kind": "pl"
        },
        "2": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "André Almeida",
          "location": "Lab. Anatomia",
          "kind": "pl"
        },
        "3": {
          "code": "PLh",
          "title": "Prática de laboratório de histologia",
          "professor": "Eliane Perlatto",
          "location": "Lab. Histologia",
          "kind": "pl"
        },
        "4": {
          "code": "PLh",
          "title": "Prática de laboratório de histologia",
          "professor": "Eliane Perlatto",
          "location": "Lab. Histologia",
          "kind": "pl"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "4": {
      "am1": {
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Priscila Duarte",
          "location": "Sala 311",
          "kind": "pe"
        },
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Priscila Duarte",
          "location": "Sala 311",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Priscila Duarte",
          "location": "Sala 311",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Priscila Duarte",
          "location": "Sala 311",
          "kind": "pe"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Bárbara Simões",
          "location": "Sala 301",
          "kind": "class"
        },
        "2": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Bárbara Simões",
          "location": "Sala 301",
          "kind": "class"
        },
        "3": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Bárbara Simões",
          "location": "Sala 301",
          "kind": "class"
        },
        "4": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Bárbara Simões",
          "location": "Sala 301",
          "kind": "class"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Manayá",
          "location": "C.S. Itamarati",
          "kind": "class"
        },
        "4": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Manayá",
          "location": "C.S. Itamarati",
          "kind": "class"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    }
  }
},
  baseScheduleByLetter: {
  "geral": {
    "A": {
      "1": {
        "am1": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Silvana Eloi",
            "location": "C.S. Heliópolis",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Silvana Eloi",
            "location": "C.S. Heliópolis",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "José Roberto",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Michelle L",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "José Roberto",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Michelle L",
            "location": "Simulação",
            "kind": "th"
          }
        },
        "am2": {
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Silvana Eloi",
            "location": "C.S. Heliópolis",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Silvana Eloi",
            "location": "C.S. Heliópolis",
            "kind": "class"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "2": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "3": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "4": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          }
        },
        "am2": {
          "1": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "2": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "3": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "4": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Priscila Duarte",
            "location": "Sala 311",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Priscila Duarte",
            "location": "Sala 311",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Priscila Duarte",
            "location": "Sala 311",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Priscila Duarte",
            "location": "Sala 311",
            "kind": "pe"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "2": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "3": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "4": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Manayá",
            "location": "C.S. Itamarati",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Manayá",
            "location": "C.S. Itamarati",
            "kind": "class"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      }
    },
    "B": {
      "1": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Michelle L",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Michelle L",
            "location": "Simulação",
            "kind": "th"
          }
        },
        "pm1": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Manayá",
            "location": "C.S. Itamarati",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Manayá",
            "location": "C.S. Itamarati",
            "kind": "class"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Suellen Campos",
            "location": "C.S. Heliópolis",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Suellen Campos",
            "location": "C.S. Heliópolis",
            "kind": "class"
          }
        },
        "pm2": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Manayá",
            "location": "C.S. Itamarati",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Manayá",
            "location": "C.S. Itamarati",
            "kind": "class"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Suellen Campos",
            "location": "C.S. Heliópolis",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Suellen Campos",
            "location": "C.S. Heliópolis",
            "kind": "class"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 301",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 301",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 301",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 301",
            "kind": "pe"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "2": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "3": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "4": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          }
        },
        "am2": {
          "1": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "2": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "André Almeida",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "3": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "4": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Eliane Perlatto",
            "location": "Lab. Histologia",
            "kind": "pl"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "2": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "4": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Renata Lima",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Renata Lima",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      }
    },
    "C": {
      "1": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 311",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 311",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 311",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Camila Said",
            "location": "Sala 311",
            "kind": "pe"
          }
        },
        "pm1": {
          "1": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "2": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "3": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Daniela Freitas",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "4": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Daniela Freitas",
            "location": "Lab. Histologia",
            "kind": "pl"
          }
        },
        "pm2": {
          "1": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Daniela Freitas",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "2": {
            "code": "PLh",
            "title": "Prática de laboratório de histologia",
            "professor": "Daniela Freitas",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "3": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "4": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Lucas Pereira",
            "location": "C.S. Novo Aarão Reis",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Lucas Pereira",
            "location": "C.S. Novo Aarão Reis",
            "kind": "class"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Bruna França",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Renata Lima",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Renata Lima",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Bruna França",
            "location": "Simulação",
            "kind": "th"
          },
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Lucas Pereira",
            "location": "C.S. Novo Aarão Reis",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Lucas Pereira",
            "location": "C.S. Novo Aarão Reis",
            "kind": "class"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Leda Souza",
            "location": "C.S. Novo Aarão Reis",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Leda Souza",
            "location": "C.S. Novo Aarão Reis",
            "kind": "class"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "2": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "3": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          },
          "4": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Bárbara Simões",
            "location": "Sala 301",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      }
    }
  }
},
  fixedClinics: {},
  specialtyClinics: {},
  extraCatalog: [],
  sourcePdf
};
export default periodDataset;
